import { useT } from "@/i18n";

// Appended to RODO consent labels: declaration of having read the General Terms (OWU).
export function OwuStatement({ testid = "owu-statement-link", linkClass = "text-foreground hover:text-slate-500" }) {
  const { t } = useT();
  const W = t.order.wizard;
  return (
    <>
      {" "}{W.owu_consent}{" "}
      <a data-testid={testid} href="/biuro-wirtualne-warszawa/owu" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className={`underline underline-offset-2 font-semibold ${linkClass}`}>{W.owu_consent_link}</a>.
    </>
  );
}
